import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

@Pipe({
  name: 'linkify',
  standalone: false
})
export class LinkifyPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {
  }

  transform(value: string, urlOnly: boolean = false): SafeHtml {
    if (!value) {
      return '';
    }
    if (urlOnly) {
      const urls = value.match(/(https?:\/\/[^\s]+)/g) || [];
      const html = urls.map(url =>
        `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`
      ).join('<br>');
      return this.sanitizer.bypassSecurityTrustHtml(html);
    }
    const escaped = value
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
    const linked = escaped.replace(
      /(https?:\/\/[^\s]+)/g,
      '<a href="$1" target="_blank" rel="noopener noreferrer">Click here</a>'
    );
    return this.sanitizer.bypassSecurityTrustHtml(linked);
  }
}
